import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
export const Loader = ({ height, color = 'marshmallowPink', }) => (React.createElement(LoaderSvg, { viewBox: "0 0 60 32", height: height, color: color },
    React.createElement("g", { transform: "translate(30,18.5455) translate(-30,-9)" },
        React.createElement(MarshOne, { id: "Marshmallow1", d: "M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767", transform: "translate(-58,-67.6467)" }),
        React.createElement(MarshTwo, { id: "Marshmallow2", d: "M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767", transform: "translate(-36,-67.6467)" }),
        React.createElement(MarshThree, { id: "Marshmallow3", d: "M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767", transform: "translate(-14,-67.6467)" }))));
const LoaderSvg = styled.svg `
  $height: ${(p) => p.height};

  path {
    fill: ${(p) => theme.colors[p.color]};
    stroke: none;
    fill-rule: evenodd;
  }

  @keyframes Marshmallow1_t {
    0% {
      transform: translate(-58.000021px, -67.6467px);
    }
    25% {
      transform: translate(-58.000021px, -67.6467px);
      animation-timing-function: cubic-bezier(0, 0, 0, 1);
    }
    37.5% {
      transform: translate(-58.000021px, -77.6467px);
      animation-timing-function: cubic-bezier(0, 0, 1, 0);
    }
    50% {
      transform: translate(-58.000021px, -67.6467px);
    }
    62.5% {
      transform: translate(-58.000021px, -67.3967px);
    }
    75% {
      transform: translate(-58.000021px, -67.8263px);
    }
    100% {
      transform: translate(-58.000021px, -67.8263px);
    }
  }

  @keyframes Marshmallow1_d {
    0% {
      /* tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767'
      );
    }
    12.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.6408L73.6592,73.3299C73.6352,72.6734,73.1892,72.0783,72.4916,71.7723C71.1747,71.1944,69.0105,70.905,66.0001,70.9039C62.9894,70.905,60.8254,71.1944,59.5084,71.7723C58.8109,72.0783,58.3648,72.6734,58.3408,73.3299L58.001,82.6408C57.983,83.1312,58.2138,83.6049,58.6366,83.9462C60.0408,85.0798,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,85.0798,73.3634,83.9462C73.7863,83.6049,74.0169,83.1312,73.999,82.6408'
      );
    }
    25% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0487L73.6592,70.9039C73.6352,70.118,73.1892,69.4057,72.4916,69.0394C71.1747,68.3477,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3477,59.5084,69.0394C58.8109,69.4057,58.3648,70.118,58.3408,70.9039L58.001,82.0487C57.983,82.6357,58.2138,83.2027,58.6366,83.6113C60.0408,84.9681,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9681,73.3634,83.6113C73.7863,83.2027,74.0169,82.6357,73.999,82.0487'
      );
    }
    50% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0513L73.6592,70.9044C73.6352,70.1184,73.1892,69.406,72.4916,69.0396C71.1747,68.3478,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3478,59.5084,69.0396C58.8109,69.406,58.3648,70.1184,58.3408,70.9044L58.001,82.0513C57.983,82.6384,58.2138,83.2055,58.6366,83.6142C60.0408,84.9713,62.4906,85.65,65.986,85.65C65.9907,85.65,65.9953,85.65,66.0001,85.65C66.0047,85.65,66.0094,85.65,66.014,85.65C69.5095,85.65,71.9593,84.9713,73.3634,83.6142C73.7863,83.2055,74.0169,82.6384,73.999,82.0513'
      );
    }
    62.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.3846L73.6592,73.0755C73.6352,72.4191,73.1892,71.8242,72.4916,71.5182C71.1747,70.9405,69.0105,70.6511,66.0001,70.65C62.9894,70.6511,60.8254,70.9405,59.5084,71.5182C58.8109,71.8242,58.3648,72.4191,58.3408,73.0755L58.001,82.3846C57.983,82.875,58.2138,83.3485,58.6366,83.6899C60.0408,84.8232,62.4906,85.39,65.986,85.39C65.9907,85.39,65.9953,85.39,66.0001,85.39C66.0047,85.39,66.0094,85.39,66.014,85.39C69.5095,85.39,71.9593,84.8232,73.3634,83.6899C73.7863,83.3485,74.0169,82.875,73.999,82.3846'
      );
    }
    75% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.1545L73.6592,70.7865C73.6352,69.985,73.1892,69.2585,72.4916,68.8848C71.1747,68.1794,69.0105,67.8259,66.0001,67.8246C62.9894,67.8259,60.8254,68.1794,59.5084,68.8848C58.8109,69.2585,58.3648,69.985,58.3408,70.7865L58.001,82.1545C57.983,82.7533,58.2138,83.3316,58.6366,83.7485C60.0408,85.1325,62.4906,85.8246,65.986,85.8246C65.9907,85.8246,65.9953,85.8246,66.0001,85.8246C66.0047,85.8246,66.0094,85.8246,66.014,85.8246C69.5095,85.8246,71.9593,85.1325,73.3634,83.7485C73.7863,83.3316,74.0169,82.7533,73.999,82.1545'
      );
    }
    100% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.1545L73.6592,70.7865C73.6352,69.985,73.1892,69.2585,72.4916,68.8848C71.1747,68.1794,69.0105,67.8259,66.0001,67.8246C62.9894,67.8259,60.8254,68.1794,59.5084,68.8848C58.8109,69.2585,58.3648,69.985,58.3408,70.7865L58.001,82.1545C57.983,82.7533,58.2138,83.3316,58.6366,83.7485C60.0408,85.1325,62.4906,85.8246,65.986,85.8246C65.9907,85.8246,65.9953,85.8246,66.0001,85.8246C66.0047,85.8246,66.0094,85.8246,66.014,85.8246C69.5095,85.8246,71.9593,85.1325,73.3634,83.7485C73.7863,83.3316,74.0169,82.7533,73.999,82.1545'
      );
    }
  }
  @keyframes Marshmallow2_t {
    0% {
      transform: translate(-36.000021px, -67.6467px);
    }
    12.5% {
      transform: translate(-36.000021px, -67.6467px);
    }
    37.5% {
      transform: translate(-36.000021px, -67.6467px);
      animation-timing-function: cubic-bezier(0, 0, 0, 1);
    }
    50% {
      transform: translate(-36.000021px, -77.6467px);
      animation-timing-function: cubic-bezier(0, 0, 1, 0);
    }
    62.5% {
      transform: translate(-36.000021px, -67.6467px);
    }
    75% {
      transform: translate(-36.000021px, -67.3967px);
    }
    87.5% {
      transform: translate(-36.000021px, -67.8263px);
    }
    100% {
      transform: translate(-36.000021px, -67.8263px);
    }
  }
  @keyframes Marshmallow2_d {
    0% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767'
      );
    }
    12.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767'
      );
    }
    25% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.6408L73.6592,73.3299C73.6352,72.6734,73.1892,72.0783,72.4916,71.7723C71.1747,71.1944,69.0105,70.905,66.0001,70.9039C62.9894,70.905,60.8254,71.1944,59.5084,71.7723C58.8109,72.0783,58.3648,72.6734,58.3408,73.3299L58.001,82.6408C57.983,83.1312,58.2138,83.6049,58.6366,83.9462C60.0408,85.0798,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,85.0798,73.3634,83.9462C73.7863,83.6049,74.0169,83.1312,73.999,82.6408'
      );
    }
    37.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0487L73.6592,70.9039C73.6352,70.118,73.1892,69.4057,72.4916,69.0394C71.1747,68.3477,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3477,59.5084,69.0394C58.8109,69.4057,58.3648,70.118,58.3408,70.9039L58.001,82.0487C57.983,82.6357,58.2138,83.2027,58.6366,83.6113C60.0408,84.9681,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9681,73.3634,83.6113C73.7863,83.2027,74.0169,82.6357,73.999,82.0487'
      );
    }
    62.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0513L73.6592,70.9044C73.6352,70.1184,73.1892,69.406,72.4916,69.0396C71.1747,68.3478,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3478,59.5084,69.0396C58.8109,69.406,58.3648,70.1184,58.3408,70.9044L58.001,82.0513C57.983,82.6384,58.2138,83.2055,58.6366,83.6142C60.0408,84.9713,62.4906,85.65,65.986,85.65C65.9907,85.65,65.9953,85.65,66.0001,85.65C66.0047,85.65,66.0094,85.65,66.014,85.65C69.5095,85.65,71.9593,84.9713,73.3634,83.6142C73.7863,83.2055,74.0169,82.6384,73.999,82.0513'
      );
    }
    75% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.3846L73.6592,73.0755C73.6352,72.4191,73.1892,71.8242,72.4916,71.5182C71.1747,70.9405,69.0105,70.6511,66.0001,70.65C62.9894,70.6511,60.8254,70.9405,59.5084,71.5182C58.8109,71.8242,58.3648,72.4191,58.3408,73.0755L58.001,82.3846C57.983,82.875,58.2138,83.3485,58.6366,83.6899C60.0408,84.8232,62.4906,85.39,65.986,85.39C65.9907,85.39,65.9953,85.39,66.0001,85.39C66.0047,85.39,66.0094,85.39,66.014,85.39C69.5095,85.39,71.9593,84.8232,73.3634,83.6899C73.7863,83.3485,74.0169,82.875,73.999,82.3846'
      );
    }
    87.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.1545L73.6592,70.7865C73.6352,69.985,73.1892,69.2585,72.4916,68.8848C71.1747,68.1794,69.0105,67.8259,66.0001,67.8246C62.9894,67.8259,60.8254,68.1794,59.5084,68.8848C58.8109,69.2585,58.3648,69.985,58.3408,70.7865L58.001,82.1545C57.983,82.7533,58.2138,83.3316,58.6366,83.7485C60.0408,85.1325,62.4906,85.8246,65.986,85.8246C65.9907,85.8246,65.9953,85.8246,66.0001,85.8246C66.0047,85.8246,66.0094,85.8246,66.014,85.8246C69.5095,85.8246,71.9593,85.1325,73.3634,83.7485C73.7863,83.3316,74.0169,82.7533,73.999,82.1545'
      );
    }
    100% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.1545L73.6592,70.7865C73.6352,69.985,73.1892,69.2585,72.4916,68.8848C71.1747,68.1794,69.0105,67.8259,66.0001,67.8246C62.9894,67.8259,60.8254,68.1794,59.5084,68.8848C58.8109,69.2585,58.3648,69.985,58.3408,70.7865L58.001,82.1545C57.983,82.7533,58.2138,83.3316,58.6366,83.7485C60.0408,85.1325,62.4906,85.8246,65.986,85.8246C65.9907,85.8246,65.9953,85.8246,66.0001,85.8246C66.0047,85.8246,66.0094,85.8246,66.014,85.8246C69.5095,85.8246,71.9593,85.1325,73.3634,83.7485C73.7863,83.3316,74.0169,82.7533,73.999,82.1545'
      );
    }
  }
  @keyframes Marshmallow3_t {
    0% {
      transform: translate(-14.000021px, -67.6467px);
    }
    25% {
      transform: translate(-14.000021px, -67.6467px);
    }
    50% {
      transform: translate(-14.000021px, -67.6467px);
      animation-timing-function: cubic-bezier(0, 0, 0, 1);
    }
    62.5% {
      transform: translate(-14.000021px, -77.6467px);
      animation-timing-function: cubic-bezier(0, 0, 1, 0);
    }
    75% {
      transform: translate(-14.000021px, -67.6467px);
    }
    87.5% {
      transform: translate(-14.000021px, -67.3967px);
    }
    100% {
      transform: translate(-14.000021px, -67.8263px);
    }
  }
  @keyframes Marshmallow3_d {
    0% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767'
      );
    }
    25% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,81.9767L73.6592,70.6087C73.6352,69.8071,73.1892,69.0806,72.4916,68.707C71.1747,68.0014,69.0105,67.648,66.0001,67.6467C62.9894,67.648,60.8254,68.0014,59.5084,68.707C58.8109,69.0806,58.3648,69.8071,58.3408,70.6087L58.001,81.9767C57.983,82.5754,58.2138,83.1538,58.6366,83.5705C60.0408,84.9546,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9546,73.3634,83.5705C73.7863,83.1538,74.0169,82.5754,73.999,81.9767'
      );
    }
    37.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.6408L73.6592,73.3299C73.6352,72.6734,73.1892,72.0783,72.4916,71.7723C71.1747,71.1944,69.0105,70.905,66.0001,70.9039C62.9894,70.905,60.8254,71.1944,59.5084,71.7723C58.8109,72.0783,58.3648,72.6734,58.3408,73.3299L58.001,82.6408C57.983,83.1312,58.2138,83.6049,58.6366,83.9462C60.0408,85.0798,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,85.0798,73.3634,83.9462C73.7863,83.6049,74.0169,83.1312,73.999,82.6408'
      );
    }
    50% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0487L73.6592,70.9039C73.6352,70.118,73.1892,69.4057,72.4916,69.0394C71.1747,68.3477,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3477,59.5084,69.0394C58.8109,69.4057,58.3648,70.118,58.3408,70.9039L58.001,82.0487C57.983,82.6357,58.2138,83.2027,58.6366,83.6113C60.0408,84.9681,62.4906,85.6467,65.986,85.6467C65.9907,85.6467,65.9953,85.6467,66.0001,85.6467C66.0047,85.6467,66.0094,85.6467,66.014,85.6467C69.5095,85.6467,71.9593,84.9681,73.3634,83.6113C73.7863,83.2027,74.0169,82.6357,73.999,82.0487'
      );
    }
    75% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.0513L73.6592,70.9044C73.6352,70.1184,73.1892,69.406,72.4916,69.0396C71.1747,68.3478,69.0105,68.0013,66.0001,68C62.9894,68.0013,60.8254,68.3478,59.5084,69.0396C58.8109,69.406,58.3648,70.1184,58.3408,70.9044L58.001,82.0513C57.983,82.6384,58.2138,83.2055,58.6366,83.6142C60.0408,84.9713,62.4906,85.65,65.986,85.65C65.9907,85.65,65.9953,85.65,66.0001,85.65C66.0047,85.65,66.0094,85.65,66.014,85.65C69.5095,85.65,71.9593,84.9713,73.3634,83.6142C73.7863,83.2055,74.0169,82.6384,73.999,82.0513'
      );
    }
    87.5% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.3846L73.6592,73.0755C73.6352,72.4191,73.1892,71.8242,72.4916,71.5182C71.1747,70.9405,69.0105,70.6511,66.0001,70.65C62.9894,70.6511,60.8254,70.9405,59.5084,71.5182C58.8109,71.8242,58.3648,72.4191,58.3408,73.0755L58.001,82.3846C57.983,82.875,58.2138,83.3485,58.6366,83.6899C60.0408,84.8232,62.4906,85.39,65.986,85.39C65.9907,85.39,65.9953,85.39,66.0001,85.39C66.0047,85.39,66.0094,85.39,66.014,85.39C69.5095,85.39,71.9593,84.8232,73.3634,83.6899C73.7863,83.3485,74.0169,82.875,73.999,82.3846'
      );
    }
    100% {
      /** tslint:disable-next-line:max-line-length */
      d: path(
        'M73.999,82.1545L73.6592,70.7865C73.6352,69.985,73.1892,69.2585,72.4916,68.8848C71.1747,68.1794,69.0105,67.8259,66.0001,67.8246C62.9894,67.8259,60.8254,68.1794,59.5084,68.8848C58.8109,69.2585,58.3648,69.985,58.3408,70.7865L58.001,82.1545C57.983,82.7533,58.2138,83.3316,58.6366,83.7485C60.0408,85.1325,62.4906,85.8246,65.986,85.8246C65.9907,85.8246,65.9953,85.8246,66.0001,85.8246C66.0047,85.8246,66.0094,85.8246,66.014,85.8246C69.5095,85.8246,71.9593,85.1325,73.3634,83.7485C73.7863,83.3316,74.0169,82.7533,73.999,82.1545'
      );
    }
  }
`;
const MarshOne = styled.path `
  animation:
    Marshmallow1_t 1.6s linear infinite both,
    Marshmallow1_d 1.6s linear infinite both;
`;
const MarshTwo = styled.path `
  animation:
    Marshmallow2_t 1.6s linear infinite both,
    Marshmallow2_d 1.6s linear infinite both;
`;
const MarshThree = styled.path `
  animation:
    Marshmallow3_t 1.6s linear infinite both,
    Marshmallow3_d 1.6s linear infinite both;
`;
//# sourceMappingURL=Loader.js.map